import { Link } from "react-router-dom";

export default function CBNHero() {
  return (
    <section className="relative w-full h-[90vh] min-h-[640px] overflow-hidden">
      <img
        src="https://public.readdy.ai/ai/img_res/daa39183bf80f66e8bb962809161d3d5.jpg"
        alt="Calm Bedroom Neutrals — A Guide to Restful Neutral Bedrooms"
        className="w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/20 to-transparent" />
      <div className="absolute inset-0 bg-gradient-to-r from-black/30 to-transparent" />

      <div className="absolute top-8 left-0 right-0 px-8 md:px-16">
        <nav
          className="flex items-center gap-2 text-white/60 text-[11px] tracking-[0.15em]"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          <Link to="/" className="hover:text-white/90 transition-colors cursor-pointer">Home</Link>
          <span className="text-white/30">/</span>
          <Link to="/bedroom" className="hover:text-white/90 transition-colors cursor-pointer">Bedroom</Link>
          <span className="text-white/30">/</span>
          <span className="text-white/80">Calm Bedroom Neutrals</span>
        </nav>
      </div>

      <div className="absolute bottom-0 left-0 right-0 px-8 md:px-16 pb-16 max-w-screen-xl">
        <span
          className="inline-block bg-[#FAF7F0]/90 text-[#6B5E53] text-[9px] px-3.5 py-1.5 rounded-full tracking-[0.22em] uppercase mb-5"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          Bedroom Guide
        </span>
        <h1
          className="text-white text-4xl md:text-6xl lg:text-7xl leading-tight max-w-3xl mb-6"
          style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
        >
          Calm Bedroom Neutrals
        </h1>
        <p
          className="text-white/70 text-sm md:text-base leading-relaxed max-w-xl"
          style={{ fontFamily: "'Inter', sans-serif", fontWeight: 300 }}
        >
          A bedroom should be the calmest room in your home. With a warm neutral palette, natural textures, and thoughtful layering, you can create a space that truly helps you rest and reset.
        </p>
      </div>
    </section>
  );
}
